// styles
import Styled from './FilterTabs.styled';
import { COLOR_VARIANTS, Typography, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';

// utils
import _map from 'lodash/map';
import _size from 'lodash/size';
import { buildTestId } from '@/utils/helpers.utils';

type FilterTabsProps = {
  tabs: { code: number; label: string }[];
  activeIndex: number;
  testId: string;
  onClick: (index: number) => void;
};

function FilterTabs({ tabs, activeIndex, testId, onClick }: FilterTabsProps) {
  return (
    <Styled.TabsWrapper>
      {_map(tabs, (tab) => {
        const isSelected = activeIndex === tab.code;
        return (
          <Styled.TabBarItem
            $expandItem={_size(tabs) > 2}
            data-testid={buildTestId(testId, `Tab_${tab.code}`)}
            key={tab.code}
            onClick={() => onClick(tab.code)}
            $isSelected={isSelected}
          >
            <Typography
              color={isSelected ? COLOR_VARIANTS.AQUA100 : COLOR_VARIANTS.MINESHAFT}
              variant={TYPOGRAPHY_VARIANT.CAPTIONSEMBLD}
              component="span"
            >
              {tab.label}
            </Typography>
          </Styled.TabBarItem>
        );
      })}
    </Styled.TabsWrapper>
  );
}

export default FilterTabs;
